/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetFaqsCountVariablesDTO = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
}>;


export type GetFaqsCountDTO = (
  { __typename?: 'Query' }
  & Pick<Types.QueryDTO, 'faqsCount'>
);


export const GetFaqsCountDocumentDTO = gql`
    query getFaqsCount($search: String) {
  faqsCount(filter: {titleInLanguage: {language: en, text: {contains: $search}}})
}
    `;

/**
 * __useGetFaqsCount__
 *
 * To run a query within a React component, call `useGetFaqsCount` and pass it any options that fit your needs.
 * When your component renders, `useGetFaqsCount` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaqsCount({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFaqsCount(baseOptions?: Apollo.QueryHookOptions<GetFaqsCountDTO, GetFaqsCountVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFaqsCountDTO, GetFaqsCountVariablesDTO>(GetFaqsCountDocumentDTO, options);
      }
export function useGetFaqsCountLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetFaqsCountDTO, GetFaqsCountVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFaqsCountDTO, GetFaqsCountVariablesDTO>(GetFaqsCountDocumentDTO, options);
        }
export type GetFaqsCountHookResult = ReturnType<typeof useGetFaqsCount>;
export type GetFaqsCountLazyQueryDTOHookResult = ReturnType<typeof useGetFaqsCountLazyQueryDTO>;
export type GetFaqsCountQueryResultDTO = Apollo.QueryResult<GetFaqsCountDTO, GetFaqsCountVariablesDTO>;